import { createAction } from 'redux-actions'

import { SET_COLLECTION_ID, SET_SEARCH_TEXT } from './constants'

export const setCollectionId = createAction(SET_COLLECTION_ID)
export const setSearchText = createAction(SET_SEARCH_TEXT)
